<template>
  <div class="container">
    <!--<imageItem v-for="image in images" :src="image.img_url" alt="" :key="image.img_uuid"></imageItem>-->
    <div class="image-wrapper" v-for="image in images" :key="image.img_uuid">
      <img v-lazy="image.img_url"  alt="" class="image-item" >
      <div class="mask-wrapper" @mouseenter="imageOnHover" @mouseleave="imageOnBlur">
        <i class="el-icon-delete icon-btn" @click="emitDelete(image)"></i>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  name: 'scrollItem',
  components: {
  },
  props: {
    images: {
      type: Array
    }
  },
  data () {
    return {
      iconShow: false,
      active_uid: null
    };
  },
  mounted () {
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    emitDelete (image) {
      console.log(image);
      this.$emit('delete', image.img_uuid);
    },
    imageOnBlur () {
      this.iconShow = false;
    },
    imageOnHover (_uid) {
      // console.log(e);
      this.active_uid = _uid;
      this.iconShow = true;
    },

    ...mapActions([])
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  display: inline-block;
  .image-wrapper {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 5px;
    .image-item {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      /*&[lazy=error] {*/
        /*!*your style here*!*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*background-color: rgba(239, 239, 239, 1);*/
      /*}*/
      /*&[lazy=loading] {*/
        /*!*your style here*!*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*background-color: rgba(239, 239, 239, 1);*/
      /*}*/
    }
    .mask-wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      z-index: 1000;
      top: 0;
      line-height: 100px;
      cursor: pointer;
      text-align: center;
      .check-text {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 70px;
        height: 20px;
        line-height: 20px;
        display: inline-block;
        font-size: 16px;
        padding: 5px;
        border-radius: 10px;
        color: #ccc;
        background-color:rgba(0, 0, 0, 0.5);
      }
      .icon-btn {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        line-height: 80px;
        text-align: center;
        font-size: 26px;
        font-weight: bold;
        color: #fff;
        &.el-icon-delete {
          color: #ff0000;
        }
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.3);
        .icon-btn {
          display: block;
        }
      }
    }
  }
}
</style>
